import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import './BreadCrumb.scss';

const vietnameseDictionary = {
  // "gioi-thieu-chung": "Giới thiệu chung",
  // "co-cau-to-chuc": "Cơ cấu tổ chức",
  // "ha-tang-mang-luoi": "Hạ tầng mạng lưới",
  // "tin-noi-bat": "Tin nổi bật",
  // "tin-hoat-dong": "Tin hoạt động",
  // "dich-vu": "Dịch vụ",
  // "thu-vien-video": "Thư viện video",
  // "thu-vien-hinh-anh": "Thư viện hình ảnh",
  // "tin-tuc": "Tin tức",
  // "gioi-thieu": "Giới thiệu",
  // "tin-chung" : "Tin chung",
  // "so-do-to-chuc" : "Sơ đồ tổ chức"
};

const BreadCrumb = ({ caseCondition }) => {

  function processBreadcrumbSegments(segments, caseCondition) {
    if (caseCondition === 'case1') {
      return segments;  // Trường hợp 1: Không thay đổi mảng
    } else if (caseCondition === 'case2') {
      return segments.slice(1);  // Trường hợp 2: Bỏ phần tử đầu tiên
    } else if (caseCondition === 'case3') {
      return segments.slice(1, -1);
    } else {
      return segments.slice(0, -1);  // Trường hợp 3: Bỏ phần tử cuối cùng
    }
  }

  const location = useLocation();
  const segments = location.pathname.split('/').filter(segment => segment !== '');
  
  const breadcrumbSegments = processBreadcrumbSegments(segments, caseCondition);

  // Hàm lấy từ có dấu từ localStorage hoặc từ vietnameseDictionary
  const getCategoryTitleWithAccent = (slug) => {
    return localStorage.getItem(slug) || vietnameseDictionary[slug] || slug;
  };

  return (
    <nav className="breadcrumbs-section">
      <ul className="breadcrumbs">
        {breadcrumbSegments.length >= 0 && (
          <li className="breadcrumb-item"><Link to="/" className="disabled">Trang chủ</Link></li>
        )}
        {breadcrumbSegments.map((segment, index) => {
          // Tạo đường dẫn breadcrumb
          const linkPath = caseCondition === 'case2'
            ? null
            : (caseCondition === 'case3'
              ? `/${segments[0]}/${breadcrumbSegments.slice(0, index + 1).join('/')}`
              : `/${breadcrumbSegments.slice(0, index + 1).join('/')}`
            );

          // Lấy tên có dấu từ localStorage hoặc vietnameseDictionary
          const titleWithAccent = getCategoryTitleWithAccent(segment);

          return (
            <li key={index} className="breadcrumb-item">
              {linkPath ? (
                <Link to={linkPath} className="disabled">
                  {titleWithAccent}
                </Link>
              ) : (
                <span className="disabled">
                  {titleWithAccent}
                </span>
              )}
            </li>
          );
        })}
      </ul>
    </nav>
  );
};

export default BreadCrumb;
